export const mapLocaleToCulture = (locale) => {
  if (!locale) return undefined;
  if (locale === 'tr') return 'tr-TR';
  if (locale === 'en') return 'en-US';
  if (locale === 'nl') return 'nl-NL';
  if (locale === 'de') return 'de-DE';
  return undefined;
};

export const resolveLocale = () => {
  if (typeof document === 'undefined') return 'tr';
  const lang = (document.documentElement.getAttribute('lang') || 'tr').toLowerCase();
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('nl')) return 'nl';
  if (lang.startsWith('de')) return 'de';
  return 'tr';
};
